import React, { ReactElement, ReactNode } from "react";
import { Control, FieldErrors, UseFormRegister } from "react-hook-form";

interface RenderChildParams<T> {
    child: ReactNode | ReactElement | undefined;
    register: UseFormRegister<T>;
    control?: Control<T>;
    errors?: FieldErrors;
}

function isInputElement(reactNode: ReactNode): reactNode is ReactElement {
    const element = reactNode as ReactElement;

    return (
        element &&
        element.props &&
        element.props.name !== undefined &&
        element.props.type !== "submit"
    );
}

function isReactElementWithChildren(reactNode: ReactNode): reactNode is ReactElement {
    const element = reactNode as ReactElement;
    return (
        element &&
        element.props !== undefined &&
        React.Children.toArray(element.props.children).length >= 1
    );
}


function RenderFormChild<T>({
    child,
    register,
    errors
}: RenderChildParams<T>): React.ReactNode {

    if (isReactElementWithChildren(child)) {
        const nestedChildren = React.Children.toArray(child.props.children);
        const children = React.Children.map(nestedChildren, (child: ReactNode) => {
            return RenderFormChild({ child, register });
        });
        return React.createElement(
            child.type, { ...child.props },
            children,
        );

    } else if (isInputElement(child)) {
        return React.createElement(child.type, {
            ...child.props,
            ...(register && register(child.props?.name)),
            helperText: errors?.[child.props?.name]?.message,
            error: Boolean(errors?.[child.props?.name]?.message)
        })
    }

    return child;
}

export default RenderFormChild;
